import { Box, Grid, Collapse, Card } from "@mui/material";
import ActiveFilters from "../../../../Components/filters/ActiveFilters";
import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
  reasonTypes,
}) => {
  const activeFilterDefinitions = [
    {
      type: "standard",
      id: "reason_type",
      label: "Reason Type",
      value: submittedData.reason_type,
    },
  ];

  return (
    <>
      <Grid item xs={12} sx={{ mb: filterOpen ? 2 : 0 }}>
        <Collapse in={filterOpen}>
          <Card>
            <Box p={4}>
              <FilterItems
                filterData={filterData}
                handleChangeFilter={handleChangeFilter}
                handleFilter={handleFilter}
                handleClearFilters={handleClearFilters}
                reasonTypes={reasonTypes}
              />
            </Box>
          </Card>
        </Collapse>
      </Grid>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
      />
    </>
  );
};

export default Filter;